(function(){
	var escapeHtml = function(html){
		var text = document.createTextNode(html);
		var p = document.createElement('p');
		p.appendChild(text);
		return p.innerHTML;
	}

	var addSpan = function(spanText, options){
		var withSpan = `<span style="font-size: .8em;">${spanText}</span>`; 
		if(options.escapeHtml){
			withSpan = escapeHtml(withSpan);
		}
		return withSpan; 
	}


	window.FS = window.FS || {};
	window.FS.resizeBeverlyWilshire = function(text, options){
		options = options || {}; 
		if(text && (typeof text === "string")){ 
			text = text.replace(/(beverly wilshire,)(?:( beverly hills,))? (a four seasons hotel)/gi, (match, g1, g2, g3) => `${g1}${g2 ? g2 : ''} ${addSpan(g3, options)}`);
		}
		return text
	};
})();
